import { render } from "./AnaliticoStatusTipo.vue?vue&type=template&id=faf30db0"
import script from "./AnaliticoStatusTipo.vue?vue&type=script&lang=js"
export * from "./AnaliticoStatusTipo.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__